import { Link } from "react-router";

import { DEFAULT_LOGO, DEFAULT_LOGO_SMALL } from "@vega-core/constants/global";
import { useTheme } from "@vega-core/context/ThemeContext/ThemeContext";
import { getLogo } from "@vega-core/helpers/getLogo.helper";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type SidebarLogoProps = {
  homePath: string;
  companyName?: string;
  isCollapsed: boolean;
  logoDark?: string;
  logoLight?: string;
  smallLogoDark?: string;
  smallLogoLight?: string;
  isMobile?: boolean;
};

export const SidebarLogo = ({
  homePath,
  companyName,
  isCollapsed,
  logoDark,
  logoLight,
  smallLogoDark,
  smallLogoLight,
  isMobile,
}: SidebarLogoProps) => {
  const { theme } = useTheme();

  return (
    <Link to={homePath}>
      <img
        alt={companyName}
        className={cnTwMerge(
          "cursor-pointer max-h-6",
          isMobile ? "min-h-6" : "",
        )}
        role="logo"
        src={getLogo(
          theme,
          isCollapsed ? DEFAULT_LOGO_SMALL : DEFAULT_LOGO,
          isCollapsed ? smallLogoLight : logoLight,
          isCollapsed ? smallLogoDark : logoDark,
        )}
      />
    </Link>
  );
};
